/**
 * Feature-tip "seen" tracking.
 *
 * Every entry-point in the Add-Meal picker (photo AI, describe AI,
 * barcode, manual, saved recipes) opens a one-time tutorial sheet the
 * FIRST time the user taps it. Tapping "فهمت" writes a flag to
 * localStorage so the user is never nagged again — but each feature
 * has its OWN flag so a user who tapped "فهمت" on photo AI still gets
 * the barcode-scan tutorial the first time they scan.
 *
 * localStorage works identically on web, Capacitor iOS WKWebView, and
 * Capacitor Android WebView — no plugin needed. See /lib/remember.js
 * for the same pattern applied to remembered credentials.
 */

const PREFIX = "calofay_tip_seen_";
const COUNT_PREFIX = "calofay_tip_ok_count_";
const AUTO_HIDE_AFTER = 3;

/** Plain "فهمت" tap — after 3 of them on the same tip, stop showing it. */
export function noteTipAcknowledged(featureKey) {
  try {
    const n = (Number(localStorage.getItem(COUNT_PREFIX + featureKey)) || 0) + 1;
    localStorage.setItem(COUNT_PREFIX + featureKey, String(n));
    if (n >= AUTO_HIDE_AFTER) markTipSeen(featureKey);
  } catch { /* ignore */ }
}

/** True the FIRST time this feature is opened (user hasn't tapped
 * "فهمت" yet). Callers show the tutorial then proceed. */
export function shouldShowTip(featureKey) {
  try { return localStorage.getItem(PREFIX + featureKey) !== "1"; }
  catch { return false; /* private mode / disabled storage → skip tip */ }
}

/** Mark a tip as seen — call this from the "فهمت" button so future
 * taps of the same feature go straight to the flow. */
export function markTipSeen(featureKey) {
  try { localStorage.setItem(PREFIX + featureKey, "1"); }
  catch { /* ignore quota / private mode — worst case is one extra tip */ }
}

/** Admin/debug helper — clears every tip flag so the tutorials play
 * again from scratch. Not exposed in the UI yet. */
export function resetAllTips() {
  try {
    for (let i = localStorage.length - 1; i >= 0; i -= 1) {
      const k = localStorage.key(i);
      if (k && (k.startsWith(PREFIX) || k.startsWith(COUNT_PREFIX))) localStorage.removeItem(k);
    }
  } catch { /* ignore */ }
}
